import { ability, defineRulesFor } from './ability'

let previousIsLoggedIn = null

const authDefineRules = (store) => {
  const { auth } = store.getState()
  const currentIsLoggedIn = auth?.isLogged

  if (previousIsLoggedIn !== currentIsLoggedIn) {
    previousIsLoggedIn = currentIsLoggedIn
    const rules = defineRulesFor(auth)
    ability.update(rules)
    console.log('[Ability] Updated rules based on auth:', rules)
  }
}

// Initialize on load
export const initializeAbilityWatcher = (store) => {
  authDefineRules(store)
  store.subscribe(() => authDefineRules(store))
}